<template>
  <div id="modalRegistrationRecommendCompany" class="modal">
    <div class="modal-background"></div>
    <!-- Modal content -->
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h2>Änderungen einreichen</h2>
          <span class="close" @click="close">&times;</span>
        </div>
        <div class="modal-body">
          <div class="text-center flex flex-col gap-2 items-center" v-show="status == 2">
            <font-awesome-icon icon="check" class="icon color-success" />
            <p>Vielen Dank!<br>Wir werden Deine Änderungen prüfen.</p>
          </div>

          <div class="text-center flex flex-col gap-2 items-center" v-show="status == 1">
            <font-awesome-icon icon="spinner" class="icon" pulse />
            <p></p>
          </div>

          <div class="text-center flex flex-col gap-2" v-show="status == 0">
            <!-- {{data}} -->

            <div>
              <label><input type="radio" name="reportTyp" value="0" id="" v-model="form.typ" @change="changeTyp"> Fehlerhafte Informationen</label>
              <div v-show="optionsTyp0">
                <textarea @input="checkInputs" v-model="form.message" class="resize-y rounded-md text-black placeholder-gray-500 w-full text-center" placeholder="Welche Informationen müssen ersetzt werden?"></textarea>
              </div>
            </div>

            <label><input type="radio" name="reportTyp" value="1" id="" v-model="form.typ" @change="changeTyp"> Aufgehoben</label>

            <button
              @click="sendAction()"
              class="button-filled text-center btn-fullsize w-full"
              :disabled="stepCompleteDisabled"
            >
              Änderungen einreichen
            </button>
          </div>

          <div class="text-center text-gray-600 font-sans" v-if="data">
            <p><small>ID: {{data.id}}</small></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalBoardReport",
  data() {
    return {
      show: this.showModal,
      stepCompleteDisabled: true,
      optionsTyp0: false,
      form: {
        typ: null,
        message: ""
      },
      status: 0
    };
  },
  props: {
    image: String,
    showModal: false,
    data: null,
    action: String
  },
  methods: {
    changeTyp() {
      if(this.form.typ == 0) { 
        this.optionsTyp0 = true
      } else {
        this.optionsTyp0 = false
      }
      this.checkInputs()
    },
    checkInputs() {
      if(this.form.typ == 0) { 
        this.stepCompleteDisabled = true
        if(this.form.message.length > 6) {
          this.stepCompleteDisabled = false
        }
      } else {
        this.stepCompleteDisabled = false
      }
    },
    sendAction() {
      this.status = 1

      this.form = {...this.form, id:this.data.id};

      if(!this.action) {
        this.action = "createSpeedlimitCorrection"
      }

      this.$store.dispatch(this.action, this.form).then((a) => {
        if (a.status == true) {
          this.status = 2
        }
      });
    },
    close() {
      this.form = {
        typ: null,
        message: ""
      }
      this.status = 0
      this.$emit("close");
    },
  },
};
</script>




